import { AbstractControl, ValidationErrors } from '@angular/forms';

const endpointRegex = /^(GET|POST|PUT|DELETE)\s.+\s.+$/;

export function EndpointValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const lines = control.value?.split('\n') || [];
  const invalidEndpoints = [];
  for (const line of lines) {
    if (!line || !endpointRegex.test(line)) {
      invalidEndpoints.push(line);
    }
  }

  return invalidEndpoints.length ? { invalidEndpoints: invalidEndpoints } : null;
}
